interface AutonomousManagementSVGProps {
  color: string;
  style: React.CSSProperties;
}

const AutonomousManagementSVG = ({
  color,
  style,
}: AutonomousManagementSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="64"
    height="50"
    viewBox="0 0 64 50"
    fill="none"
  >
    <g clipPath="url(#clip0_465_6259)">
      <path
        d="M16.7226 15.0904C16.7226 15.2021 16.6331 15.2916 16.5214 15.2916C16.4096 15.2916 16.3201 15.2021 16.3201 15.0904C16.3201 14.9786 16.4096 14.8892 16.5214 14.8892C16.6331 14.8892 16.7226 14.9786 16.7226 15.0904Z"
        stroke={color}
        strokeWidth="1.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.1069 12.1395C14.7887 11.6588 15.6271 11.3682 16.5214 11.3682C17.4156 11.3682 18.254 11.6588 18.9358 12.1395"
        stroke={color}
        strokeWidth="1.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.4845 9.25532C20.076 8.26046 18.3658 7.6792 16.5102 7.6792C14.6546 7.6792 12.9443 8.26046 11.5359 9.25532"
        stroke={color}
        strokeWidth="1.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.586 24.3349H3.00693C1.6879 24.3349 0.625977 23.273 0.625977 21.9539V3.00693C0.625977 1.6879 1.6879 0.625977 3.00693 0.625977H30.1923C31.5113 0.625977 32.5732 1.6879 32.5732 3.00693V5.54438"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M8.45069 24.335L6.99753 28.0126H16.5884H23.5859"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M25.8775 14.1406V32.987"
        stroke={color}
        strokeWidth="1.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M47.8203 25.3857L46.3336 27.3531C45.0592 29.041 44.5898 31.0307 45.6405 32.8863L47.3955 35.9938"
        stroke={color}
        strokeWidth="1.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M52.7945 25.3857L54.2812 27.3531C55.5556 29.041 56.025 31.0307 54.9743 32.8863L53.1858 36.0721"
        stroke={color}
        strokeWidth="1.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M46.3336 27.353C45.0257 29.0521 44.5562 31.0418 45.6405 32.8862"
        stroke={color}
        strokeWidth="1.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M50.313 17.3374V32.182"
        stroke={color}
        strokeWidth="1.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M52.6157 5.39893C54.1247 5.72309 55.5667 6.47203 56.7404 7.64574C57.9141 8.81945 58.6631 10.2614 58.9873 11.7705"
        stroke={color}
        strokeWidth="1.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M53.0069 1.73242C55.2873 2.22426 57.467 3.35326 59.2444 5.13059C61.0217 6.90792 62.1507 9.08766 62.6425 11.368"
        stroke={color}
        strokeWidth="1.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M52.7498 9.04297C53.3646 9.17711 53.9459 9.47892 54.4266 9.95958C54.9072 10.4402 55.209 11.0215 55.3432 11.6363"
        stroke={color}
        strokeWidth="1.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.562 32.9866V20.5117"
        stroke={color}
        strokeWidth="1.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.4485 19.2598C29.5104 20.0423 30.8182 20.5118 32.2379 20.5118C34.8871 20.5118 37.1563 18.8909 38.1176 16.5882L47.5073 15.7163C48.055 16.6777 49.0834 17.326 50.2683 17.326C52.0233 17.326 53.4429 15.9064 53.4429 14.1514C53.4429 12.3964 52.0233 10.9768 50.2683 10.9768C49.0834 10.9768 48.055 11.6251 47.5073 12.5865L38.1176 11.7146C37.1563 9.41185 34.8871 7.79102 32.2379 7.79102C28.7279 7.79102 25.8775 10.6415 25.8775 14.1514"
        stroke={color}
        strokeWidth="1.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.2379 11.7705C33.5457 11.7705 34.6076 12.8324 34.6076 14.1403C34.6076 15.4481 33.5457 16.5101 32.2379 16.5101"
        stroke={color}
        strokeWidth="1.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.2198 32.3496C25.2068 32.3496 21.9539 35.6025 21.9539 39.6154V49.3852H36.4856V39.6154C36.4856 36.8097 34.8983 34.3729 32.562 33.1656"
        stroke={color}
        strokeWidth="1.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_465_6259">
        <rect width="63.2685" height="50" fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export default AutonomousManagementSVG;
